/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_SubheadingInputs */

const en_hero_subheading = /** @type {(inputs: Hero_SubheadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you're not there, you're essentially invisible.`)
};

/** @type {(inputs: Hero_SubheadingInputs) => LocalizedString} */
const et_hero_subheading = () => /** @type {LocalizedString} */ ('hero_subheading')

/**
* | output |
* | --- |
* | "If you're not there, you're essentially invisible." |
*
* @param {Hero_SubheadingInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_subheading = /** @type {((inputs?: Hero_SubheadingInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_SubheadingInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_hero_subheading(inputs)
	return en_hero_subheading(inputs)
});